(() => {
  if (customElements.get('lp-free-shipping-label')) return;
  class FreeShippingLabel extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form[data-js-product-form]');
      this.destination = this.closest('lp-petal-delivery')?.querySelector('[data-petal-destination]');
      this.price = Number(this.dataset.price);
      this.onSale = this.dataset.onSale === 'true';
      this.shippable = this.dataset.shippable === 'true';
      this.onVariant = ({ currentVariant }) => {
        this.price = currentVariant ? Number(currentVariant.price) : NaN;
        this.onSale = Number(currentVariant?.compare_at_price) > this.price;
        this.shippable = Boolean(currentVariant && currentVariant.requires_shipping !== false);
        this.update();
      };
      this.onDestination = () => this.update();
      this.bind = () => {
        if (this.bus || !this.form || !window.themeCore?.EventBus) return;
        this.bus = window.themeCore.EventBus;
        this.eventName = 'form:' + this.form.getAttribute('id') + ':change-variant';
        this.bus.listen(this.eventName, this.onVariant);
      };
      this.bind();
      document.addEventListener('DOMContentLoaded', this.bind, { once: true });
      window.addEventListener('load', this.bind, { once: true });
      this.form?.addEventListener('change', this.bind);
      this.destination?.addEventListener('change', this.onDestination);
      this.update();
    }
    disconnectedCallback() {
      this.bus?.remove(this.eventName, this.onVariant);
      this.bus = null;
      document.removeEventListener('DOMContentLoaded', this.bind);
      window.removeEventListener('load', this.bind);
      this.form?.removeEventListener('change', this.bind);
      this.destination?.removeEventListener('change', this.onDestination);
    }
    update() {
      this.hidden = !(
        this.dataset.currency === 'USD' &&
        !this.onSale &&
        this.shippable &&
        Number.isFinite(this.price) &&
        this.price >= Number(this.dataset.threshold) &&
        this.dataset.countries.split(',').includes(this.destination?.value)
      );
    }
  }
  customElements.define('lp-free-shipping-label', FreeShippingLabel);
})();

